export { default as AllBrandsQuery } from './AllBrandsQuery';